import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { HeaderInfoBlockNewsItemData } from '../../../typings/header';
import { Balloon, BalloonSize } from '../../Balloon/Balloon';
import { StyledLink, StyledLinkTheme } from '../../StyledLink/StyledLink';
import { HeaderExpandedInfoBlock } from '../HeaderExpandedInfoBlock/HeaderExpandedInfoBlock';

import './NewsExpandedInfoBlock.css';
import * as keyset from './NewsExpandedInfoBlock.i18n';

const i18n = i18nFactory(keyset);

const NEWS_ARCHIVE_LINK = 'https://yandex.ru/adv/news?tag=direkt';

interface NewsExpandedInfoBlockProps {
    fetchItems: () => void;
    items: Array<HeaderInfoBlockNewsItemData>;
    isLoading?: boolean;
    error?: string;
}

interface NewsExpandedInfoBlockState {
    isOpen: boolean;
}

export class NewsExpandedInfoBlock extends React.PureComponent<
    NewsExpandedInfoBlockProps,
    NewsExpandedInfoBlockState
> {
    constructor(props: NewsExpandedInfoBlockProps) {
        super(props);

        this.state = {
            isOpen: true
        };
    }

    render() {
        const { fetchItems, isLoading, items, error } = this.props;
        const { isOpen } = this.state;

        return (
            <HeaderExpandedInfoBlock
                title={i18n('news')}
                isOpen={isOpen}
                onClick={this.onClick}
                fetchItems={fetchItems}
                error={error}
                isLoading={isLoading}
                moreInfoHref={NEWS_ARCHIVE_LINK}
            >
                {items.map(({ href, title, description, isNew }, key) => (
                    <div
                        className={Bem.cls('news-expanded-info-block', 'item')}
                        key={key}
                    >
                        <div
                            className={Bem.cls(
                                'news-expanded-info-block',
                                'item-title'
                            )}
                        >
                            {title}
                            <Balloon
                                cls={Bem.cls(
                                    'news-expanded-info-block',
                                    'balloon'
                                )}
                                visible={isNew}
                                size={BalloonSize.s}
                            />
                        </div>
                        <StyledLink
                            theme={StyledLinkTheme.blue}
                            cls={Bem.cls(
                                'news-expanded-info-block',
                                'item-link'
                            )}
                            href={href}
                        >
                            {description}
                        </StyledLink>
                    </div>
                ))}
            </HeaderExpandedInfoBlock>
        );
    }

    private onClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };
}
